module.exports = __webpack_public_path__ + "static/media/pen.88b80ee5.svg";